import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerRows, productImage } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-paper px-3 py-20 sm:px-5 sm:py-28" data-id="element-207" data-mp="1mniu7gv3flg1">
      <div className="mx-auto max-w-xl" data-id="element-208" data-mp="1mplgpqx1ewg0">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-209" data-mp="1ho5xm4ef7009">
          Special Launch Offer
        </h2>

        <div className="mt-10 overflow-hidden rounded-[2rem] border-[3px] border-ink bg-white shadow-pop-lg" data-id="element-210" data-mp="ozrz7njf61o6">
          <div className="flex items-center gap-4 border-b-[3px] border-ink bg-royal px-5 py-5 text-white sm:px-8" data-id="element-211" data-mp="13wrfs0w914us">
            <img src={productImage} alt="" className="h-20 w-auto shrink-0 sm:h-24" data-id="element-212" data-mp="yxojb4uc46yf" />
            <p className="font-display text-lg font-black leading-tight sm:text-2xl" data-id="element-213" data-mp="2fbxzvcsc4rep">
              Get the Complete CAREER READY™ Pack
            </p>
          </div>

          <div className="px-3 pb-8 pt-6 sm:px-8" data-id="element-214" data-mp="2af7kkroctzuc">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-ink-soft" data-id="element-215" data-mp="pj5s0gnh24ab">
              Your Purchase Includes
            </p>
            <dl className="mt-2" data-id="element-216" data-mp="ulemxijwngf2">
              {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-3.5 text-sm" data-id="element-217" data-mp="zjg8ca4szrtp">
                  <dt className="flex items-start gap-2.5 text-ink" data-id="element-218" data-mp="13j73eq1d4u41">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-219" data-mp="6usevr9whw52" />
                    {row.label}
                  </dt>
                  <dd className={`shrink-0 font-bold ${row.value === 'FREE' ? 'rounded-md bg-sun px-2 py-0.5 text-ink' : 'text-royal'}`} data-id="element-220" data-mp="fufimjq3re1a">
                    {row.value}
                  </dd>
                </div>)}
            </dl>

            <p id="checkout" className="mt-8 scroll-mt-48 text-center text-xs font-extrabold uppercase tracking-[0.16em] text-royal sm:scroll-mt-56" data-id="element-221" data-mp="3k9fce8iq9gr1">
              One Payment. No Subscription.
            </p>
            <p className="flex items-end justify-center gap-2 pt-2" data-id="element-222" data-mp="vdnvcksi3v7n">
              <span className="font-display text-7xl font-black leading-none tracking-tight text-ink" data-id="element-223" data-mp="qfutg3y8dnd6">
                $27
              </span>
              <span className="pb-2 text-sm font-bold text-ink-soft" data-id="element-224" data-mp="106h1nd3mbblu">USD</span>
            </p>
            <p className="mx-auto mt-4 max-w-xs text-center text-sm leading-relaxed text-ink-soft" data-id="element-225" data-mp="108ti1ltq9dws">
              Six volumes. Five bonuses. One organized career readiness teaching
              system.
            </p>

            <CtaButton label="Yes! Get My CAREER READY™ Pack" className="mt-7 sm:w-full sm:px-6 sm:text-xl" data-id="element-226" data-mp="lhb742fq69ka" />

            <p className="mt-5 text-center text-[11px] font-medium text-ink-soft" data-id="element-227" data-mp="hfg1wmuobc18">
              Instant Download · One-Time Payment · Lifetime Access · 7-Day
              Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}